// @flow
import React from 'react';
import { get } from 'lodash';

import { MemberSignInContainer } from 'Components/widgets/member-nav/member-sign-in/MemberSignIn.container.jsx';
import { useRouter } from 'Client/router/useRouter';
import { LoggedNav } from './logged-nav/LoggedNav.jsx';
import { QuickLoggedNavContainer } from './quicklogged-nav/QuickLoggedNav.container';

type Props = {
  cmsContent: *,
  userInfo: UserInfoSummary,
};
export function MemberNav(props: Props) {
  const { userInfo, cmsContent } = props;
  const {
    location: {
      queryParams: { cxo_neolid: cxoNeolid },
    },
  } = useRouter<UrlParams, GlobalQueryParams>();

  if (!cmsContent) {
    return null;
  }

  if (userInfo.isQuickLoggedIn) {
    return <QuickLoggedNavContainer cmsContent={cmsContent} />;
  }

  if (userInfo.isLoggedIn || cxoNeolid) {
    return <LoggedNav {...props} />;
  }

  return (
    <MemberSignInContainer
      cmsContentAuthentication={get(cmsContent, 'account.authentication', {})}
    />
  );
}
